import React from 'react';
import { Shirt } from 'lucide-react';

export default function LooksStrip({ toggles, active, onToggle }) {
  return (
    <div className="shrink-0 mt-3 flex items-center gap-2 min-w-0" data-testid="looks-panel">
      <span className="shrink-0 flex items-center gap-1.5 font-osd text-[11px] tracking-widest text-[#f5a623]" aria-hidden>
        <Shirt className="w-4 h-4" /> LOOKS
      </span>
      <div role="toolbar" aria-label="Outfit toggles" className="flex-1 min-w-0 flex gap-2 overflow-x-auto no-scrollbar snap-x pb-1 sm:flex-wrap sm:overflow-visible">
        {toggles.map((t, i) => {
          const on = active.includes(t.id);
          return (
            <button key={t.id} type="button" onClick={() => onToggle(t)} aria-pressed={on} data-testid={`look-toggle-${i}`}
                    className={`header-tab snap-start shrink-0 h-10 px-3 font-osd text-xs tracking-wider border-2 rounded-sm whitespace-nowrap ${on ? 'header-tab-active' : ''}`}>
              <span className={`inline-block w-2 h-2 rounded-full mr-2 align-middle ${on ? 'bg-[#1a0e05]' : 'bg-[#5a3418]'}`} aria-hidden />
              {t.name.toUpperCase()}
            </button>
          );
        })}
      </div>
    </div>
  );
}
